<template>
    <div class="test-results-details">
        <b-notification v-if="error"
                        type="is-danger is-light"
                        aria-close-label="Close notification"
                        role="alert">{{ error }}</b-notification>
        <template v-else-if="!isLoading">
            <p class="title" v-if="targetBuild">{{ targetBuild.name }}</p>
            <p class="subtitle" v-if="this.requestsDate">
                {{ formStringDate(this.requestsDate) }}
            </p>
            <table class="table is-striped is-fullwidth is-hoverable">
                <tbody>
                <tr>
                    <th v-for="mtrName in this.mtrNamesForTarget" :key="mtrName">{{ mtrName }}</th>
                </tr>
                <tr>
                    <td v-for="mtrName in this.mtrNamesForTarget" :key="`results-${mtrName}`">
                        <template v-for="uploadRequest in uploadRequestsForMtr(mtrName, PARSER_RESULT_CODES.SUCCESS)">
                            <b-tooltip :label="JSON.parse(uploadRequest.params).Image" :key="uploadRequest.id" type="is-dark">
                                <router-link :to="generateUploadRequestLink(uploadRequest.id)"
                                             class="button is-small is-text upload-request-link"
                                             exact>
                                    <test-result result="MTR_RES_PASSED"/>
                                </router-link>
                            </b-tooltip>
                        </template>
                    </td>
                </tr>
                <tr>
                    <td v-for="mtrName in this.mtrNamesForTarget" :key="`results-${mtrName}`">
                        <template v-for="uploadRequest in uploadRequestsForMtr(mtrName, PARSER_RESULT_CODES.NO_XML)">
                            <b-tooltip :label="JSON.parse(uploadRequest.params).Image" :key="uploadRequest.id" type="is-dark">
                                <router-link :to="generateUploadRequestLink(uploadRequest.id)"
                                             class="button is-small is-text upload-request-link"
                                             exact>
                                    <test-result result="MTR_RES_INFO"/>
                                </router-link>
                            </b-tooltip>
                        </template>
                    </td>
                </tr>
                <tr>
                    <td v-for="mtrName in this.mtrNamesForTarget" :key="`results-${mtrName}`">
                        <template v-for="uploadRequest in uploadRequestsForMtr(mtrName, PARSER_RESULT_CODES.FAILURE)">
                            <b-tooltip :label="JSON.parse(uploadRequest.params).Image" :key="uploadRequest.id" type="is-dark">
                                <router-link :to="generateUploadRequestLink(uploadRequest.id)"
                                             class="button is-small is-text upload-request-link"
                                             exact>
                                    <test-result result="MTR_RES_FAILED"/>
                                </router-link>
                            </b-tooltip>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>


            <template v-if="currentUploadRequest">
                <div class="title">{{ JSON.parse(currentUploadRequest.params).mtr }}</div>
                <upload-request-info :upload-request="currentUploadRequest"/>
            </template>

        </template>

        <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TestResult from "@/components/TestResult.vue";
import {PARSER_RESULT_CODES} from "@/utils/constants";
import UploadRequestInfo from "@/components/UploadRequestInfo.vue";

    export default {
        name: "UploadRequestResultsDetails",
        components: {UploadRequestInfo, TestResult},
        props: {
            requestsDate: [String, Number],
            targetBuildId: [String, Number],
        },
        data() {
            return {
                isLoading: false,
                error: null,
            }
        },
        created() {
            this.fetchData();
        },
        watch: {
            requestsDate() {
                this.fetchData();
            },
            targetBuildId() {
                this.fetchData();
            },
        },
        computed: {
            PARSER_RESULT_CODES() {
                return PARSER_RESULT_CODES
            },
            ...mapGetters('TargetBuilds', [
                'targetBuildById',
            ]),
            ...mapGetters('UploadRequests', [
                'uploadRequestsForTarget',
                'currentUploadRequestById',
                'mtrNamesForTarget',
            ]),
            ...mapGetters('Auth', [
                'hasAccess',
            ]),
            targetBuild() {
                return this.targetBuildById(this.targetBuildId);
            },
            currentUploadRequest() {
                const currentUploadRequestId = this.$route.query.currentUploadRequestId;
                if (currentUploadRequestId == null) return null;
                return this.currentUploadRequestById(currentUploadRequestId);
            },
        },
        methods: {
            ...mapActions('UploadRequests', [
                'fetchUploadRequestsForTarget',
            ]),
            async fetchData() {
                if (!this.hasAccess) return;
                this.isLoading = true;
                try {
                    await this.fetchUploadRequestsForTarget({
                        requestsDate: this.requestsDate,
                        targetBuildId: this.targetBuildId,
                    });
                } catch(message) {
                    this.error = message;
                }
                this.isLoading = false;
            },
            uploadRequestsForMtr(mtrName, requestResults) {
                return this.uploadRequestsForTarget.filter(request => {
                    let requestJSON = JSON.parse(request.params)
                    return requestJSON.mtr === mtrName && requestResults.includes(request.result)
                });
            },
            formStringDate(date) {
                let dateObject = new Date(date)
                const options = {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                return (new Intl.DateTimeFormat('en-US', options)).format(dateObject);
            },
            generateUploadRequestLink(uploadRequestId) {
                const query = Object.assign({}, this.$route.query, {
                    currentUploadRequestId: uploadRequestId,
                });
                return { name: 'UploadRequestResultsIndex', query };
            },
        },
    }
</script>

<style lang="scss" scoped>
    .upload-request-link {
        opacity: 0.3;
        &.router-link-active {
            opacity: 1;
            border: 1px solid $link;
            border-radius: 50%;
        }
    }
</style>